import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import type { PriceRestorationColumns } from '../types'
import type { Column } from '@app/components/base/Table/types'
import type { MonitoringValidationConfigStoresLinksDataSource } from '@app/types/dataSource'

const columnTitleMap: Record<keyof PriceRestorationColumns, string> = {
  firstCompetitorId: 'Магазин 1',
  secondCompetitorId: 'Магазин 2',
  removeButton: ''
}

const getColumnsOptions = (): Array<Column<PriceRestorationColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof PriceRestorationColumns>

  return columnKeys.map(key => {
    const column: Column<PriceRestorationColumns> = {
      key,
      width: '50%',
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const getColumns = (): Array<Column<MonitoringValidationConfigStoresLinksDataSource>> =>
  [
    ...getColumnsFromMap<PriceRestorationColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    })
  ] as Array<Column<MonitoringValidationConfigStoresLinksDataSource>>

export default getColumns
